import { combineReducers } from "redux";
import authReducer from "./auth.reducer";
import adminReducer from "./admin.reducer";
import alertReducer from "./alert.reducer";
import pollReducer from "./poll.reducer";
import referralReducer from "./referrals.reducer";
import pollOptionsReducer from "./pollOptions.reducer";
import {
  statesReducer,
  constituencyReducer,
  constituenciesMpReducer,
} from "./pollBharat.reducer";
import reporting_dashboardReducer from "./report.reducer";

export default combineReducers({
  authReducer,
  adminReducer,
  alertReducer,
  pollReducer,
  referralReducer,
  statesReducer,
  constituencyReducer,
  constituenciesMpReducer,
  pollOptionsReducer,
  reporting_dashboardReducer
});
